/**
 * Country SEO i18n — Wave 13
 * New countries: Myanmar, Cambodia, Laos, Sri Lanka (expanded), Malta, Iceland, Luxembourg
 * Language gaps filled: UAE, Qatar, Jordan, Lebanon, Tunisia, Algeria
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE13: CountrySEOMap = {

  uae: {
    zh: {
      title: '阿联酋呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '阿联酋呼叫中心：阿拉伯语/英语双语座席，GST时区，CSAT 95%，从3美元/小时起。',
      heroTitle: '阿联酋呼叫中心 — 多语言支持',
      heroSubtitle: '以nearshore价格为阿联酋市场提供优质多语言客户服务。',
    },
    ja: {
      title: 'UAEコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'UAE向けコールセンター：アラビア語/英語バイリンガル、GST時間帯、3$/時間〜。',
      heroTitle: 'UAEコールセンター — 多言語サポート',
      heroSubtitle: 'ニアショア価格でUAE市場向けプレミアム多言語サポート。',
    },
    ko: {
      title: 'UAE 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: 'UAE 콜센터: 아랍어/영어 이중 언어, GST 시간대, 시간당 3달러부터.',
      heroTitle: 'UAE 콜센터 — 다국어 지원',
      heroSubtitle: '니어쇼어 가격으로 UAE 시장 프리미엄 다국어 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Förenade Arabemiraten | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för UAE: arabisk- och engelsktalande agenter, GST-tidszon, från 3 $/h.',
      heroTitle: 'Callcenter för UAE — Flerspråkigt Stöd',
      heroSubtitle: 'Premium flerspråkig kundtjänst för UAE-marknaden.',
    },
    da: {
      title: 'Callcenter De Forenede Arabiske Emirater | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til UAE: arabisk- og engelsktalende agenter, GST-tidszone, fra 3 $/t.',
      heroTitle: 'Callcenter til UAE — Flersproget Support',
      heroSubtitle: 'Premium flersproget kundeservice til UAE-markedet.',
    },
  },

  qatar: {
    zh: {
      title: '卡塔尔呼叫中心 | 阿拉伯语/英语客服 | Call IT Dev',
      description: '卡塔尔呼叫中心：阿拉伯语/英语双语座席，AST时区，从4美元/小时起。',
      heroTitle: '卡塔尔呼叫中心 — 双语支持',
      heroSubtitle: '以nearshore价格为卡塔尔市场提供优质双语客户服务。',
    },
    ja: {
      title: 'カタールコールセンター | アラビア語/英語サポート | Call IT Dev',
      description: 'カタール向けコールセンター：アラビア語/英語バイリンガル、AST時間帯、4$/時間〜。',
      heroTitle: 'カタールコールセンター — バイリンガルサポート',
      heroSubtitle: 'ニアショア価格でカタール市場向けプレミアムサポート。',
    },
    ko: {
      title: '카타르 콜센터 | 아랍어/영어 고객 서비스 | Call IT Dev',
      description: '카타르 콜센터: 아랍어/영어 이중 언어, AST 시간대, 시간당 4달러부터.',
      heroTitle: '카타르 콜센터 — 이중 언어 지원',
      heroSubtitle: '니어쇼어 가격으로 카타르 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Qatar | Arabisk/Engelskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Qatar: arabisk-/engelsktalande agenter, AST-tidszon, från 4 $/h.',
      heroTitle: 'Callcenter för Qatar — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium tvåspråkig kundtjänst för Qatar-marknaden.',
    },
    da: {
      title: 'Callcenter Qatar | Arabisk/Engelsksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Qatar: arabisk-/engelsktalende agenter, AST-tidszone, fra 4 $/t.',
      heroTitle: 'Callcenter til Qatar — Tosproget Support',
      heroSubtitle: 'Premium tosproget kundeservice til Qatar-markedet.',
    },
  },

  jordan: {
    zh: {
      title: '约旦呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '约旦呼叫中心：阿拉伯语母语座席，EET时区，从3美元/小时起。',
      heroTitle: '约旦呼叫中心 — 阿拉伯语支持',
      heroSubtitle: '以nearshore价格提供优质阿拉伯语客户服务。',
    },
    ja: {
      title: 'ヨルダンコールセンター | アラビア語カスタマーサポート | Call IT Dev',
      description: 'ヨルダン向けコールセンター：アラビア語ネイティブ、EET時間帯、3$/時間〜。',
      heroTitle: 'ヨルダンコールセンター — アラビア語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムアラビア語顧客体験。',
    },
    ko: {
      title: '요르단 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '요르단 콜센터: 아랍어 원어민, EET 시간대, 시간당 3달러부터.',
      heroTitle: '요르단 콜센터 — 아랍어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 아랍어 고객 경험.',
    },
    sv: {
      title: 'Callcenter Jordanien | Arabiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Jordanien: arabisktalande agenter, EET-tidszon, från 3 $/h.',
      heroTitle: 'Callcenter för Jordanien — Arabiskspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst på arabiska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Jordan | Arabisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Jordan: arabisktalende agenter, EET-tidszone, fra 3 $/t.',
      heroTitle: 'Callcenter til Jordan — Arabisksproget Support',
      heroSubtitle: 'Premium kundeservice på arabisk til nearshore-priser.',
    },
  },

  lebanon: {
    zh: {
      title: '黎巴嫩呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '黎巴嫩呼叫中心：阿拉伯语/法语/英语三语座席，EET时区，从3美元/小时起。',
      heroTitle: '黎巴嫩呼叫中心 — 三语支持',
      heroSubtitle: '以nearshore价格提供阿拉伯语/法语/英语三语客户服务。',
    },
    ja: {
      title: 'レバノンコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'レバノン向けコールセンター：アラビア語/仏語/英語トリリンガル、3$/時間〜。',
      heroTitle: 'レバノンコールセンター — トリリンガルサポート',
      heroSubtitle: 'ニアショア価格でプレミアム多言語顧客体験。',
    },
    ko: {
      title: '레바논 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '레바논 콜센터: 아랍어/불어/영어 삼개국어, EET 시간대, 시간당 3달러부터.',
      heroTitle: '레바논 콜센터 — 삼개국어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 다국어 고객 경험.',
    },
  },

  tunisia: {
    zh: {
      title: '突尼斯呼叫中心 | 法语客服外包 | Call IT Dev',
      description: '突尼斯呼叫中心：法语母语座席，CET时区，CSAT 95%，从2.5美元/小时起。',
      heroTitle: '突尼斯呼叫中心 — 法语母语支持',
      heroSubtitle: '以最低价格提供优质法语客户服务。',
    },
    ja: {
      title: 'チュニジアコールセンター | フランス語カスタマーサポート | Call IT Dev',
      description: 'チュニジア向けコールセンター：フランス語ネイティブ、CET時間帯、2.5$/時間〜。',
      heroTitle: 'チュニジアコールセンター — フランス語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムフランス語顧客体験。',
    },
    ko: {
      title: '튀니지 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '튀니지 콜센터: 프랑스어 원어민, CET 시간대, 시간당 2.5달러부터.',
      heroTitle: '튀니지 콜센터 — 프랑스어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 프랑스어 고객 경험.',
    },
    nl: {
      title: 'Callcenter Tunesië | Franstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Tunesië: Franstalige agenten, CET-tijdzone, vanaf 2.5 $/u.',
      heroTitle: 'Callcenter voor Tunesië — Franstalig Support',
      heroSubtitle: 'Premium Franstalige klantenservice tegen nearshore-prijzen.',
    },
  },

  algeria: {
    zh: {
      title: '阿尔及利亚呼叫中心 | 法语/阿拉伯语客服 | Call IT Dev',
      description: '阿尔及利亚呼叫中心：法语/阿拉伯语双语座席，CET时区，从2.5美元/小时起。',
      heroTitle: '阿尔及利亚呼叫中心 — 双语支持',
      heroSubtitle: '以nearshore价格提供法语/阿拉伯语双语客户服务。',
    },
    ja: {
      title: 'アルジェリアコールセンター | 仏語/アラビア語サポート | Call IT Dev',
      description: 'アルジェリア向けコールセンター：仏語/アラビア語バイリンガル、CET時間帯、2.5$/時間〜。',
      heroTitle: 'アルジェリアコールセンター — バイリンガルサポート',
      heroSubtitle: 'ニアショア価格でプレミアム仏語/アラビア語顧客体験。',
    },
    ko: {
      title: '알제리 콜센터 | 프랑스어/아랍어 고객 서비스 | Call IT Dev',
      description: '알제리 콜센터: 프랑스어/아랍어 이중 언어, CET 시간대, 시간당 2.5달러부터.',
      heroTitle: '알제리 콜센터 — 이중 언어 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 프랑스어/아랍어 고객 경험.',
    },
    nl: {
      title: 'Callcenter Algerije | Frans/Arabisch Klantenservice | Call IT Dev',
      description: 'Callcenter voor Algerije: Frans/Arabisch tweetalige agenten, CET, vanaf 2.5 $/u.',
      heroTitle: 'Callcenter voor Algerije — Tweetalig Support',
      heroSubtitle: 'Premium tweetalige klantenservice tegen nearshore-prijzen.',
    },
  },

  malta: {
    en: {
      title: 'Call Center Malta | Multilingual Customer Service | Call IT Dev',
      description: 'Call center for Malta: English/Maltese-speaking agents, CET timezone, CSAT 95%, from €5/hr.',
      heroTitle: 'Call Center for Malta — Multilingual Support',
      heroSubtitle: 'Premium customer service for the Maltese market at nearshore prices.',
    },
    fr: {
      title: 'Centre d\'appel Malte | Service Client Multilingue | Call IT Dev',
      description: 'Centre d\'appel pour Malte : agents anglophones, fuseau CET, dès 5 $/h.',
      heroTitle: 'Centre d\'appel pour Malte — Support multilingue',
      heroSubtitle: 'Service client premium pour le marché maltais.',
    },
    it: {
      title: 'Call Center Malta | Assistenza Clienti Multilingue | Call IT Dev',
      description: 'Call center per Malta: agenti anglofoni/italofoni, fuso CET, da 5 $/h.',
      heroTitle: 'Call Center per Malta — Supporto Multilingue',
      heroSubtitle: 'Assistenza clienti premium per il mercato maltese.',
    },
    de: {
      title: 'Call Center Malta | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Malta: englischsprachige Agenten, CET-Zeitzone, ab 5 $/h.',
      heroTitle: 'Call Center für Malta — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den maltesischen Markt.',
    },
  },

  iceland: {
    en: {
      title: 'Call Center Iceland | Nordic Customer Service | Call IT Dev',
      description: 'Call center for Iceland: English-speaking agents, GMT timezone, CSAT 95%, from €6/hr.',
      heroTitle: 'Call Center for Iceland — Nordic Support',
      heroSubtitle: 'Premium customer service for the Icelandic market.',
    },
    fr: {
      title: 'Centre d\'appel Islande | Service Client Nordique | Call IT Dev',
      description: 'Centre d\'appel pour l\'Islande : agents anglophones, fuseau GMT, dès 6 $/h.',
      heroTitle: 'Centre d\'appel pour l\'Islande — Support nordique',
      heroSubtitle: 'Service client premium pour le marché islandais.',
    },
    sv: {
      title: 'Callcenter Island | Nordisk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Island: engelsktalande agenter, GMT-tidszon, från 6 $/h.',
      heroTitle: 'Callcenter för Island — Nordiskt Stöd',
      heroSubtitle: 'Premium kundtjänst för den isländska marknaden.',
    },
    da: {
      title: 'Callcenter Island | Nordisk Kundeservice | Call IT Dev',
      description: 'Callcenter til Island: engelsktalende agenter, GMT-tidszone, fra 6 $/t.',
      heroTitle: 'Callcenter til Island — Nordisk Support',
      heroSubtitle: 'Premium kundeservice til det islandske marked.',
    },
  },

  luxembourg: {
    en: {
      title: 'Call Center Luxembourg | Multilingual Customer Service | Call IT Dev',
      description: 'Call center for Luxembourg: French/German/English trilingual agents, CET, from €3/hr.',
      heroTitle: 'Call Center for Luxembourg — Trilingual Support',
      heroSubtitle: 'Premium trilingual customer service for the Luxembourg market.',
    },
    fr: {
      title: 'Centre d\'appel Luxembourg | Service Client Trilingue | Call IT Dev',
      description: 'Centre d\'appel pour le Luxembourg : agents trilingues FR/DE/EN, fuseau CET, dès 8 $/h.',
      heroTitle: 'Centre d\'appel pour le Luxembourg — Support trilingue',
      heroSubtitle: 'Service client premium trilingue pour le marché luxembourgeois.',
    },
    de: {
      title: 'Callcenter Luxemburg | Dreisprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Luxemburg: FR/DE/EN dreisprachige Agenten, CET-Zeitzone, ab 8 $/h.',
      heroTitle: 'Callcenter für Luxemburg — Dreisprachiger Support',
      heroSubtitle: 'Premium dreisprachiger Kundenservice für den luxemburgischen Markt.',
    },
    nl: {
      title: 'Callcenter Luxemburg | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Luxemburg: FR/DE/EN drietalige agenten, CET, vanaf 8 $/u.',
      heroTitle: 'Callcenter voor Luxemburg — Meertalig Support',
      heroSubtitle: 'Premium meertalige klantenservice voor de Luxemburgse markt.',
    },
  },
};
